import ReasonsToBelieve from './reasons-to-believe';

export default ReasonsToBelieve;
